import React from "react"

const NotFound: React.FC = () => (
  <div className="content-container">
    <img alt="Page not found." src="https://i.imgflip.com/4aq4be.jpg" style={{ width: "80%", margin: "auto" }}/>
  </div>
)

export default NotFound
